(function () {
  if (window.shtoReviewsJs) return;
  window.shtoReviewsJs = true;
  function setMargin() {
    var root = document.getElementById('shto-reviews');
    var header = document.getElementById('header');
    if (!root || !header) return;
    var position = getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return;
    root.style.scrollMarginTop = Math.round(header.getBoundingClientRect().height) + 'px';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setMargin);
  else setMargin();
  window.addEventListener('resize', setMargin, { passive: true });
  document.addEventListener('shopify:section:load', setMargin);
})();
